/**
 * Set de iconos MDI como SVG (solo los usados en la app).
 * Sustituye la fuente @mdi/font para reducir peso y evitar CSS bloqueante.
 */
import { h, defineComponent } from 'vue'
import {
  mdiAccount,
  mdiAccountCheck,
  mdiAccountCircle,
  mdiAccountCircleOutline,
  mdiAccountGroup,
  mdiAccountOutline,
  mdiAlert,
  mdiAlertCircleOutline,
  mdiArrowLeft,
  mdiArrowTopRight,
  mdiBell,
  mdiBellOff,
  mdiBellOutline,
  mdiBellRingOutline,
  mdiBookmark,
  mdiBookmarkCheck,
  mdiBookmarkMultiple,
  mdiBookmarkOutline,
  mdiBookmarkPlus,
  mdiBookOpenVariant,
  mdiBroadcast,
  mdiBullseye,
  mdiCalendar,
  mdiCalendarCheck,
  mdiCalendarWeek,
  mdiCalendarEnd,
  mdiCalendarOutline,
  mdiCalendarRange,
  mdiCalendarStart,
  mdiCalendarClock,
  mdiCalendarClockOutline,
  mdiCamera,
  mdiChartBar,
  mdiChartBoxOutline,
  mdiChartLine,
  mdiCheck,
  mdiCheckAll,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiContentCopy,
  mdiTwitter,
  mdiWhatsapp,
  mdiCash,
  mdiCheckboxMultipleMarked,
  mdiChevronDown,
  mdiDomain,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiClockCheck,
  mdiClockOutline,
  mdiClose,
  mdiCloseCircle,
  mdiCog,
  mdiContentSave,
  mdiCrown,
  mdiDatabase,
  mdiDelete,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiDownload,
  mdiEarth,
  mdiEmail,
  mdiEmailCheck,
  mdiEmailLock,
  mdiEmailOutline,
  mdiEmoticonSadOutline,
  mdiEye,
  mdiEyeCheck,
  mdiEyeCircleOutline,
  mdiEyeOff,
  mdiEyeOffOutline,
  mdiEyeOutline,
  mdiFileDocument,
  mdiFileDocumentEditOutline,
  mdiFilm,
  mdiFilter,
  mdiFilterOff,
  mdiFire,
  mdiFlagOutline,
  mdiFormatListBulleted,
  mdiFormatAlignCenter,
  mdiFormatAlignJustify,
  mdiFormatAlignLeft,
  mdiFormatAlignRight,
  mdiFormatBold,
  mdiFormatFloatLeft,
  mdiFormatFloatRight,
  mdiFormatHeader2,
  mdiFormatHeader3,
  mdiFormatItalic,
  mdiFormatListChecks,
  mdiFormatListNumbered,
  mdiFormatParagraph,
  mdiFormatTitle,
  mdiGoogle,
  mdiHeart,
  mdiHeartBox,
  mdiHeartMultiple,
  mdiHeartOutline,
  mdiHelpCircle,
  mdiHistory,
  mdiInformationOutline,
  mdiLightningBolt,
  mdiLock,
  mdiLogoutVariant,
  mdiMagnify,
  mdiMapMarker,
  mdiMapMarkerMultiple,
  mdiMapMarkerOutline,
  mdiMonitorMultiple,
  mdiMovie,
  mdiMusic,
  mdiMovieOpen,
  mdiImage,
  mdiLinkVariant,
  mdiLinkVariantOff,
  mdiNoteText,
  mdiOpenInNew,
  mdiPalette,
  mdiPencil,
  mdiPencilBox,
  mdiPencilBoxMultiple,
  mdiPencilBoxOutline,
  mdiPlay,
  mdiPlayCircle,
  mdiPlaylistPlus,
  mdiPlaylistCheck,
  mdiPublish,
  mdiFeather,
  mdiImageText,
  mdiTextLong,
  mdiTagMultipleOutline,
  mdiThumbUpOutline,
  mdiPower,
  mdiRefresh,
  mdiRocketLaunch,
  mdiShieldAccount,
  mdiSort,
  mdiShareVariant,
  mdiCreationOutline,
  mdiStar,
  mdiStarCircle,
  mdiStarFourPoints,
  mdiStarOutline,
  mdiSync,
  mdiSofa,
  mdiTicketConfirmation,
  mdiTag,
  mdiTagMultiple,
  mdiTagOutline,
  mdiTent,
  mdiTarget,
  mdiTelevision,
  mdiTheater,
  mdiTelevisionBox,
  mdiTelevisionGuide,
  mdiTrophy,
  mdiTrendingUp,
  mdiViewDashboard,
  mdiViewGridOutline,
  mdiWeatherNight,
  mdiWeatherSunset,
  mdiWhiteBalanceSunny,
  mdiPlusBox,
  mdiHome,
  mdiMenu,
  mdiPlus,
  mdiMinus,
  mdiInformation,
  mdiAlertCircle,
  mdiCheckboxMarked,
  mdiCheckboxBlankOutline,
  mdiMinusBox,
  mdiCircle,
  mdiArrowUp,
  mdiArrowDown,
  mdiMenuDown,
  mdiMenuRight,
  mdiArrowRight,
  mdiCalendarEdit,
  mdiCircleOutline,
  mdiCommentOutline,
  mdiCompassOffOutline,
  mdiCrosshairsGps,
  mdiFile,
  mdiImageOutline,
  mdiLockCheckOutline,
  mdiLockOutline,
  mdiMovieSearchOutline,
  mdiTextBoxMultiple,
  mdiTextBoxOutline,
  mdiTextBoxSearchOutline,
  mdiThumbUp,
  mdiUpload,
  mdiViewGridPlus,
  mdiChartTimelineVariant,
  mdiContentSaveOutline,
  mdiTrophyOutline,
  mdiWeb
} from '@mdi/js'

const viewBox = '0 0 24 24'

function path(d) {
  return { path: d, viewBox }
}

export const mdiSvgSet = {
  'mdi-arrow-right': path(mdiArrowRight),
  'mdi-calendar-edit': path(mdiCalendarEdit),
  'mdi-circle-outline': path(mdiCircleOutline),
  'mdi-comment-outline': path(mdiCommentOutline),
  'mdi-compass-off-outline': path(mdiCompassOffOutline),
  'mdi-crosshairs-gps': path(mdiCrosshairsGps),
  'mdi-file': path(mdiFile),
  'mdi-image-outline': path(mdiImageOutline),
  'mdi-lock-check-outline': path(mdiLockCheckOutline),
  'mdi-lock-outline': path(mdiLockOutline),
  'mdi-movie-search-outline': path(mdiMovieSearchOutline),
  'mdi-text-box-multiple': path(mdiTextBoxMultiple),
  'mdi-text-box-outline': path(mdiTextBoxOutline),
  'mdi-text-box-search-outline': path(mdiTextBoxSearchOutline),
  'mdi-thumb-up': path(mdiThumbUp),
  'mdi-upload': path(mdiUpload),
  'mdi-view-grid-plus': path(mdiViewGridPlus),
  'mdi-chart-timeline-variant': path(mdiChartTimelineVariant),
  'mdi-content-save-outline': path(mdiContentSaveOutline),
  'mdi-trophy-outline': path(mdiTrophyOutline),
  'mdi-web': path(mdiWeb),
  'mdi-account': path(mdiAccount),
  'mdi-account-check': path(mdiAccountCheck),
  'mdi-account-circle': path(mdiAccountCircle),
  'mdi-account-circle-outline': path(mdiAccountCircleOutline),
  'mdi-account-group': path(mdiAccountGroup),
  'mdi-account-outline': path(mdiAccountOutline),
  'mdi-alert': path(mdiAlert),
  'mdi-alert-circle-outline': path(mdiAlertCircleOutline),
  'mdi-arrow-left': path(mdiArrowLeft),
  'mdi-arrow-top-right': path(mdiArrowTopRight),
  'mdi-bell': path(mdiBell),
  'mdi-bell-off': path(mdiBellOff),
  'mdi-bell-outline': path(mdiBellOutline),
  'mdi-bell-ring-outline': path(mdiBellRingOutline),
  'mdi-bookmark': path(mdiBookmark),
  'mdi-bookmark-check': path(mdiBookmarkCheck),
  'mdi-bookmark-multiple': path(mdiBookmarkMultiple),
  'mdi-bookmark-outline': path(mdiBookmarkOutline),
  'mdi-bookmark-plus': path(mdiBookmarkPlus),
  'mdi-book-open-variant': path(mdiBookOpenVariant),
  'mdi-broadcast': path(mdiBroadcast),
  'mdi-bullseye': path(mdiBullseye),
  'mdi-calendar': path(mdiCalendar),
  'mdi-calendar-check': path(mdiCalendarCheck),
  'mdi-calendar-week': path(mdiCalendarWeek),
  'mdi-calendar-end': path(mdiCalendarEnd),
  'mdi-calendar-outline': path(mdiCalendarOutline),
  'mdi-calendar-range': path(mdiCalendarRange),
  'mdi-calendar-start': path(mdiCalendarStart),
  'mdi-calendar-clock': path(mdiCalendarClock),
  'mdi-calendar-clock-outline': path(mdiCalendarClockOutline),
  'mdi-camera': path(mdiCamera),
  'mdi-chart-bar': path(mdiChartBar),
  'mdi-chart-box-outline': path(mdiChartBoxOutline),
  'mdi-chart-line': path(mdiChartLine),
  'mdi-check': path(mdiCheck),
  'mdi-check-all': path(mdiCheckAll),
  'mdi-check-circle': path(mdiCheckCircle),
  'mdi-check-circle-outline': path(mdiCheckCircleOutline),
  'mdi-checkbox-multiple-marked': path(mdiCheckboxMultipleMarked),
  'mdi-chevron-down': path(mdiChevronDown),
  'mdi-chevron-left': path(mdiChevronLeft),
  'mdi-chevron-right': path(mdiChevronRight),
  'mdi-chevron-up': path(mdiChevronUp),
  'mdi-clock-check': path(mdiClockCheck),
  'mdi-clock-outline': path(mdiClockOutline),
  'mdi-close': path(mdiClose),
  'mdi-close-circle': path(mdiCloseCircle),
  'mdi-cog': path(mdiCog),
  'mdi-content-copy': path(mdiContentCopy),
  'mdi-content-save': path(mdiContentSave),
  'mdi-crown': path(mdiCrown),
  'mdi-cash': path(mdiCash),
  'mdi-database': path(mdiDatabase),
  'mdi-domain': path(mdiDomain),
  /* Facebook: solo la "f" (sin círculo), path oficial del logotipo */
  'mdi-facebook': { path: 'M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-6.9 6.9-6.9 1.65 0 2.863.366 3.267.366v3.6h-2.242c-1.004 0-1.332.476-1.332 1.206v2.314h3.644l-.486 3.691h-3.158v7.98H24V0H0v23.691h9.101z', viewBox: '0 0 24 24' },
  'mdi-twitter': path(mdiTwitter),
  'mdi-whatsapp': path(mdiWhatsapp),
  'mdi-delete': path(mdiDelete),
  'mdi-delete-outline': path(mdiDeleteOutline),
  'mdi-dots-vertical': path(mdiDotsVertical),
  'mdi-download': path(mdiDownload),
  'mdi-earth': path(mdiEarth),
  'mdi-email': path(mdiEmail),
  'mdi-email-check': path(mdiEmailCheck),
  'mdi-email-lock': path(mdiEmailLock),
  'mdi-email-outline': path(mdiEmailOutline),
  'mdi-emoticon-sad-outline': path(mdiEmoticonSadOutline),
  'mdi-eye': path(mdiEye),
  'mdi-eye-check': path(mdiEyeCheck),
  'mdi-eye-circle-outline': path(mdiEyeCircleOutline),
  'mdi-eye-off': path(mdiEyeOff),
  'mdi-eye-off-outline': path(mdiEyeOffOutline),
  'mdi-eye-outline': path(mdiEyeOutline),
  'mdi-file-document': path(mdiFileDocument),
  'mdi-file-document-edit-outline': path(mdiFileDocumentEditOutline),
  'mdi-film': path(mdiFilm),
  'mdi-filter': path(mdiFilter),
  'mdi-filter-off': path(mdiFilterOff),
  'mdi-fire': path(mdiFire),
  'mdi-flag-outline': path(mdiFlagOutline),
  'mdi-format-list-bulleted': path(mdiFormatListBulleted),
  'mdi-format-align-center': path(mdiFormatAlignCenter),
  'mdi-format-align-justify': path(mdiFormatAlignJustify),
  'mdi-format-align-left': path(mdiFormatAlignLeft),
  'mdi-format-align-right': path(mdiFormatAlignRight),
  'mdi-format-bold': path(mdiFormatBold),
  'mdi-format-float-left': path(mdiFormatFloatLeft),
  'mdi-format-float-right': path(mdiFormatFloatRight),
  'mdi-format-header-2': path(mdiFormatHeader2),
  'mdi-format-header-3': path(mdiFormatHeader3),
  'mdi-format-italic': path(mdiFormatItalic),
  'mdi-format-list-checks': path(mdiFormatListChecks),
  'mdi-format-list-numbered': path(mdiFormatListNumbered),
  'mdi-format-paragraph': path(mdiFormatParagraph),
  'mdi-format-title': path(mdiFormatTitle),
  'mdi-google': path(mdiGoogle),
  'mdi-heart': path(mdiHeart),
  'mdi-heart-box': path(mdiHeartBox),
  'mdi-heart-multiple': path(mdiHeartMultiple),
  'mdi-heart-outline': path(mdiHeartOutline),
  'mdi-help-circle': path(mdiHelpCircle),
  'mdi-history': path(mdiHistory),
  'mdi-information-outline': path(mdiInformationOutline),
  'mdi-lightning-bolt': path(mdiLightningBolt),
  'mdi-lock': path(mdiLock),
  'mdi-logout-variant': path(mdiLogoutVariant),
  'mdi-magnify': path(mdiMagnify),
  'mdi-map-marker': path(mdiMapMarker),
  'mdi-map-marker-multiple': path(mdiMapMarkerMultiple),
  'mdi-map-marker-outline': path(mdiMapMarkerOutline),
  'mdi-monitor-multiple': path(mdiMonitorMultiple),
  'mdi-movie': path(mdiMovie),
  'mdi-movie-open': path(mdiMovieOpen),
  'mdi-music': path(mdiMusic),
  'mdi-image': path(mdiImage),
  'mdi-link-variant': path(mdiLinkVariant),
  'mdi-link-variant-off': path(mdiLinkVariantOff),
  'mdi-note-text': path(mdiNoteText),
  'mdi-open-in-new': path(mdiOpenInNew),
  'mdi-palette': path(mdiPalette),
  'mdi-pencil': path(mdiPencil),
  'mdi-pencil-box': path(mdiPencilBox),
  'mdi-pencil-box-multiple': path(mdiPencilBoxMultiple),
  'mdi-pencil-box-outline': path(mdiPencilBoxOutline),
  'mdi-play': path(mdiPlay),
  'mdi-play-circle': path(mdiPlayCircle),
  'mdi-playlist-plus': path(mdiPlaylistPlus),
  'mdi-playlist-check': path(mdiPlaylistCheck),
  'mdi-publish': path(mdiPublish),
  'mdi-feather': path(mdiFeather),
  'mdi-image-text': path(mdiImageText),
  'mdi-text-long': path(mdiTextLong),
  'mdi-tag-multiple-outline': path(mdiTagMultipleOutline),
  'mdi-thumb-up-outline': path(mdiThumbUpOutline),
  'mdi-plus-box': path(mdiPlusBox),
  'mdi-power': path(mdiPower),
  'mdi-refresh': path(mdiRefresh),
  'mdi-rocket-launch': path(mdiRocketLaunch),
  'mdi-shield-account': path(mdiShieldAccount),
  'mdi-share-variant': path(mdiShareVariant),
  'mdi-creation-outline': path(mdiCreationOutline),
  'mdi-sort': path(mdiSort),
  'mdi-star': path(mdiStar),
  'mdi-star-circle': path(mdiStarCircle),
  'mdi-star-four-points': path(mdiStarFourPoints),
  'mdi-star-outline': path(mdiStarOutline),
  'mdi-sync': path(mdiSync),
  'mdi-sofa': path(mdiSofa),
  'mdi-ticket-confirmation': path(mdiTicketConfirmation),
  'mdi-tag': path(mdiTag),
  'mdi-tag-multiple': path(mdiTagMultiple),
  'mdi-tag-outline': path(mdiTagOutline),
  'mdi-tent': path(mdiTent),
  'mdi-target': path(mdiTarget),
  'mdi-theater': path(mdiTheater),
  'mdi-television': path(mdiTelevision),
  'mdi-view-grid-outline': path(mdiViewGridOutline),
  'mdi-television-box': path(mdiTelevisionBox),
  'mdi-television-guide': path(mdiTelevisionGuide),
  'mdi-trophy': path(mdiTrophy),
  'mdi-trending-up': path(mdiTrendingUp),
  'mdi-view-dashboard': path(mdiViewDashboard),
  'mdi-weather-night': path(mdiWeatherNight),
  'mdi-weather-sunset': path(mdiWeatherSunset),
  'mdi-white-balance-sunny': path(mdiWhiteBalanceSunny),
  'mdi-home': path(mdiHome),
  'mdi-menu': path(mdiMenu),
  'mdi-plus': path(mdiPlus),
  'mdi-minus': path(mdiMinus),
  'mdi-information': path(mdiInformation),
  'mdi-alert-circle': path(mdiAlertCircle),
  'mdi-checkbox-marked': path(mdiCheckboxMarked),
  'mdi-checkbox-blank-outline': path(mdiCheckboxBlankOutline),
  'mdi-minus-box': path(mdiMinusBox),
  'mdi-circle': path(mdiCircle),
  'mdi-arrow-up': path(mdiArrowUp),
  'mdi-arrow-down': path(mdiArrowDown),
  'mdi-menu-down': path(mdiMenuDown),
  'mdi-menu-right': path(mdiMenuRight),
}

/** Componente que resuelve el nombre del icono (mdi-xxx) al path SVG para Vuetify */
const MdiSvgIconWrapper = defineComponent({
  name: 'MdiSvgIconWrapper',
  props: {
    icon: { type: [String, Array, Object], default: null },
    tag: { type: [String, Object, Function], required: true },
  },
  setup(props, { attrs }) {
    return () => {
      const name = typeof props.icon === 'string' ? props.icon.trim() : ''
      const def = name ? mdiSvgSet[name] : null
      const pathData = def?.path ?? null
      const tag = props.tag || 'i'
      const viewBox = def?.viewBox ?? '0 0 24 24'
      return h(tag, {
        class: attrs.class,
        style: attrs.style,
        ...attrs,
      }, [
        pathData ? h('svg', {
          class: 'v-icon__svg',
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox,
          role: 'img',
          'aria-hidden': 'true',
          style: { width: '100%', height: '100%' },
        }, [h('path', { d: pathData, fill: 'inherit' })]) : null,
      ])
    }
  },
})

/** Set para Vuetify: debe tener `component` que recibe el nombre y resuelve al path */
export const mdiSet = {
  component: MdiSvgIconWrapper,
}
